import api from '../api/user-auth';
export default {
    logout () {
        return new Promise((resolve, reject) => {
            api.logout().then(({ data }) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
}